import { Common, ApiBind } from './common.model';
import { DealDetail } from './deal-detail.model';

export class Deal extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  @ApiBind({ column: 'details', model: (value) => value.map(v => new DealDetail(v)) })
  details: DealDetail[];

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }
}
